
import { Icon } from './Icon';
import { Badge,  } from 'react-bootstrap';

export const keyBadge = (id?: string)=> {
   return  id ? <Badge bg="secondary" className='me-1'><Icon name="key"/> {id}</Badge> : ''
}